// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1-chB","header":"MergedInvoice_header__2cyl7"};